import React from 'react';
import { ChevronLeft, HelpCircle, BookOpen, Camera, Megaphone } from 'lucide-react';

const MODES = [
  {
    id: 'story',
    title: 'Story Mode',
    description: 'AI-guided conversation that adapts to your answers',
    icon: BookOpen,
    color: 'text-purple-400',
    bg: 'bg-purple-500/15',
  },
  {
    id: 'qa',
    title: 'Q&A Game',
    description: 'Answer guided questions by category',
    icon: HelpCircle,
    color: 'text-blue-400',
    bg: 'bg-blue-500/15',
  },
  {
    id: 'moment',
    title: 'Quick Moment',
    description: 'Capture a spontaneous moment with optional caption',
    icon: Camera,
    color: 'text-green-400',
    bg: 'bg-green-500/15',
  },
  {
    id: 'callout',
    title: 'Weekly Callout',
    description: 'Respond to this week\'s family question',
    icon: Megaphone,
    color: 'text-amber-400',
    bg: 'bg-amber-500/15',
  },
];

function ModeSelector({ relative, families, selectedFamily, onSelectMode, onBack }) {
  // Find active weekly callout for relative's families
  const activeCallout = (() => {
    const relativeFamilyUuids = (relative.families || []).map(f => f.uuid);
    for (const fam of families) {
      if (relativeFamilyUuids.includes(fam.uuid) && fam.weeklyCallout) {
        return fam.weeklyCallout;
      }
    }
    return null;
  })();

  return (
    <div className="min-h-screen bg-gray-900 text-white p-4">
      <div className="flex items-center gap-3 mb-6">
        <button onClick={onBack} className="p-2 hover:bg-gray-800 rounded-full transition-colors">
          <ChevronLeft className="w-6 h-6" />
        </button>
        <div>
          <h2 className="text-lg font-bold">Record for {relative.name}</h2>
          <p className="text-gray-400 text-sm">Choose a recording mode</p>
        </div>
      </div>

      <div className="space-y-3">
        {MODES.map((mode) => {
          // Hide Weekly Callout if no active callout
          if (mode.id === 'callout' && !activeCallout) return null;

          const Icon = mode.icon;
          return (
            <button
              key={mode.id}
              onClick={() => onSelectMode(mode.id, mode.id === 'callout' ? activeCallout : null)}
              className="w-full flex items-center gap-4 p-4 rounded-2xl bg-gray-800 hover:bg-gray-750 transition-colors text-left"
            >
              <div className={`w-12 h-12 rounded-xl ${mode.bg} flex items-center justify-center flex-shrink-0`}>
                <Icon className={`w-6 h-6 ${mode.color}`} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-white">{mode.title}</p>
                <p className="text-gray-400 text-sm mt-0.5">{mode.description}</p>
                {mode.id === 'callout' && activeCallout && (
                  <p className="text-amber-400 text-xs mt-1 truncate">
                    "{activeCallout.question || activeCallout.summary}"
                  </p>
                )}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default ModeSelector;
